export default {
  JOIN_TEAM_TOURNAMENT: 'JOIN_TEAM_TOURNAMENT',
  LEAVE_TEAM_TOURNAMENT: 'LEAVE_TEAM_TOURNAMENT',
  DELETE_CONFIRMATION: 'DELETE_CONFIRMATION',
  ADD_NEW_STREAMER: 'ADD_NEW_STREAMER',
  IMPORT_STANDINGS_RESULTS: 'IMPORT_STANDINGS_RESULTS',
  HOW_TO_IMPORT_PLAYERS: 'HOW_TO_IMPORT_PLAYERS',
  HOW_TO_IMPORT_STANDINGS: 'HOW_TO_IMPORT_STANDINGS',
};
